module.exports = __webpack_public_path__ + "img/agence.27ce6471.svg";